import script from "./MergedAcademyMedals.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./MergedAcademyMedals.vue?vue&type=script&setup=true&lang=ts"
export * from "./MergedAcademyMedals.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./MergedAcademyMedals.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__